const getters = {
  // currentUser
  isAuthed: state => state.currentUser.authData.isAuthed,
  token: state => state.currentUser.authData.token,
  currentUser: state => state.currentUser.userInfo,
  // currentSetting
  modules: state => state.currentSetting.currentMenus,
  subMenus: state => state.currentSetting.activeModule.children,
  activeModule: state => state.currentSetting.activeModule,
  activeModulePath: state => state.currentSetting.activeModule.path,
  activeMenu: state => state.currentSetting.activeMenu,
  permissions: state => state.currentSetting.permissions,
  configs: state => state.currentSetting.configs,
  menuAuth: state => state.currentSetting.menuAuth,
  // searchInfo
  searchShop: state => state.searchInfo.data.shop,
  searchDate: state => state.searchInfo.data.date,
  searchDateRange: state => state.searchInfo.data.dateRange,
  // currentTenant
  currentTenant: state => state.currentTenant.tenantInfo,
  // windowResize
  windowSize: state => state.windowResize.windowSize,
  continueCreate: state => state.continueCreate.data
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js